import { Link } from 'react-router-dom';
import type { Product } from '@rosita/shared';
import { formatEur } from '../../lib/format';
import { getProductBadges } from '../../lib/product';
import { useAppSettings } from '../../lib/appSettings';
import { Badge } from './Badge';
import styles from './ProductCard.module.scss';

interface Props {
  product: Product;
  className?: string;
}

export function ProductCard({ product, className }: Props): JSX.Element {
  const { newBadgeExpiryDays } = useAppSettings();
  const primary = product.images.find((i) => i.isPrimary) ?? product.images[0];
  const { isNew, isOutOfStock } = getProductBadges(product, newBadgeExpiryDays);
  const hasSale = product.salePrice !== null && product.salePrice !== undefined;

  return (
    <Link
      to={`/produtos/${product.slug}`}
      className={[styles.card, className ?? ''].filter(Boolean).join(' ')}
    >
      <div className={`${styles.media} ${isOutOfStock ? styles.mediaOut : ''}`}>
        {primary ? (
          <img
            src={primary.thumbUrl}
            alt={primary.altText ?? product.name}
            loading="lazy"
          />
        ) : (
          <div className={styles.placeholder} aria-hidden />
        )}
        <div className={styles.badges}>
          {isNew ? <Badge variant="new" /> : null}
          {isOutOfStock ? <Badge variant="out" /> : null}
        </div>
      </div>
      <div className={styles.body}>
        <span className={styles.name}>{product.name}</span>
        <span className={styles.priceRow}>
          {hasSale ? (
            <>
              <span className={styles.sale}>{formatEur(product.salePrice ?? product.price)}</span>
              <span className={styles.original}>{formatEur(product.price)}</span>
            </>
          ) : (
            <span>{formatEur(product.price)}</span>
          )}
        </span>
      </div>
    </Link>
  );
}
